import { useState, useEffect } from "react";
import { BRAND, GradText, Section } from "../brand";

export default function HeroSlide({ proposalData, onAccept, isMobile, isDemo }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => setVisible(true), 200);
  }, []);

  const proposalStats = [
    { label: "Locations", value: proposalData.locations || "—" },
    { label: "Monthly", value: proposalData.monthlyFee || "—" },
    { label: "Minutes", value: proposalData.minutesIncluded || "—" },
    { label: "Setup", value: proposalData.setupFee || "—" },
  ];
  const demoStats = [
    { label: "Won't leave voicemail", value: "62%" },
    { label: "Calls after-hours", value: "40%" },
    { label: "AI pickup time", value: "<2s" },
  ];
  const stats = isDemo ? demoStats : proposalStats;

  return (
    <Section style={{ background: BRAND.dark }}>
      <div
        style={{
          position: "absolute",
          width: 550,
          height: 550,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(249,115,22,0.12) 0%, transparent 70%)",
          top: -120,
          right: -120,
          animation: "float 6s ease-in-out infinite",
        }}
      />
      <div
        style={{
          position: "absolute",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 70%)",
          bottom: -100,
          left: -100,
          animation: "float 8s ease-in-out infinite reverse",
        }}
      />
      <div
        style={{
          maxWidth: 860,
          margin: "0 auto",
          width: "100%",
          zIndex: 1,
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(30px)",
          transition: "all 0.9s cubic-bezier(0.16,1,0.3,1)",
        }}
      >
        <a
          href="https://restohost.ai"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginBottom: isMobile ? 20 : 28,
          }}
        >
          <img
            src="/logos/RH-SVG-2.svg"
            alt="RestoHost"
            style={{
              height: isMobile ? 28 : 36,
              width: "auto",
              display: "block",
            }}
          />
        </a>
        {!isDemo && (
          <div
            style={{
              display: "inline-block",
              padding: "6px 16px",
              borderRadius: 100,
              background: "rgba(249,115,22,0.12)",
              border: "1px solid rgba(249,115,22,0.25)",
              fontSize: 13,
              color: BRAND.orange,
              fontWeight: 600,
              letterSpacing: 0.5,
              marginBottom: isMobile ? 18 : 28,
            }}
          >
            Proposal Agreement
          </div>
        )}
        <h1
          style={{
            fontSize: isMobile ? 32 : 52,
            fontWeight: 800,
            color: BRAND.white,
            lineHeight: 1.08,
            margin: "0 0 16px 0",
            fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
          }}
        >
          {isDemo ? (
            <>
              The AI receptionist{" "}
              <GradText
                style={{
                  fontSize: isMobile ? 32 : 52,
                  fontWeight: 800,
                  fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
                }}
              >
                your restaurant needs
              </GradText>
            </>
          ) : (
            <>
              Prepared for{" "}
              <GradText
                style={{
                  fontSize: isMobile ? 32 : 52,
                  fontWeight: 800,
                  fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
                }}
              >
                {proposalData.clientName || "Your Restaurant"}
              </GradText>
            </>
          )}
        </h1>
        <p
          style={{
            fontSize: isMobile ? 15 : 19,
            color: "rgba(255,255,255,0.6)",
            lineHeight: 1.6,
            maxWidth: 620,
            marginBottom: isMobile ? 24 : 36,
          }}
        >
          {isDemo
            ? "Answers every call. Books every table. Pays for itself."
            : "Every missed call is a missed reservation. Let's fix that — starting today."}
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${stats.length}, 1fr)`,
            gap: isMobile ? 16 : 32,
            marginBottom: isMobile ? 24 : 36,
          }}
        >
          {stats.map((c, i) => (
            <div
              key={i}
              style={{
                textAlign: "left",
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(15px)",
                transition: `all 0.6s cubic-bezier(0.16,1,0.3,1) ${0.3 + i * 0.08}s`,
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? 28 : 44,
                  fontWeight: 800,
                  color: BRAND.white,
                  lineHeight: 1.05,
                  fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
                }}
              >
                {c.value}
              </div>
              <div
                style={{
                  fontSize: isMobile ? 10 : 11,
                  color: BRAND.gray,
                  textTransform: "uppercase",
                  letterSpacing: 1.2,
                  marginTop: 8,
                  lineHeight: 1.3,
                }}
              >
                {c.label}
              </div>
            </div>
          ))}
        </div>
        {!isDemo && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 20,
              marginBottom: isMobile ? 20 : 28,
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                fontSize: 13,
                color: "rgba(255,255,255,0.35)",
              }}
            >
              Prepared by:{" "}
              <strong style={{ color: "rgba(255,255,255,0.7)" }}>
                {proposalData.preparedBy || "RestoHost AI"}
              </strong>
              <span style={{ margin: "0 12px", opacity: 0.3 }}>|</span>
              Date:{" "}
              <strong style={{ color: "rgba(255,255,255,0.7)" }}>
                {proposalData.date}
              </strong>
            </div>
          </div>
        )}
        <button
          onClick={onAccept}
          style={{
            padding: isMobile ? "16px 36px" : "18px 48px",
            borderRadius: 14,
            border: "none",
            background: BRAND.gradient,
            color: BRAND.white,
            fontSize: isMobile ? 17 : 19,
            fontWeight: 700,
            cursor: "pointer",
            boxShadow: "0 8px 32px rgba(249,115,22,0.3)",
            transition: "all 0.3s ease",
            width: isMobile ? "100%" : "auto",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 12px 40px rgba(249,115,22,0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 8px 32px rgba(249,115,22,0.3)";
          }}
        >
          {isDemo ? "Book a Demo →" : "Accept Proposal →"}
        </button>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 28,
          left: "50%",
          transform: "translateX(-50%)",
          color: "rgba(255,255,255,0.25)",
          fontSize: 13,
          animation: "bounce 2s infinite",
          zIndex: 1,
        }}
      >
        {isDemo ? "↓ See how it works" : "↓ Scroll to review what we discussed"}
      </div>
    </Section>
  );
}
